import Vue from "vue";
import { Message } from "element-ui";
import store from "@/store";
import { websocketUrl } from "@/const/request_api";

let v = new Vue();
v.$message = Message;
var webSocket = null;
var isConnect = false; //连接状态
var globalCallback = function (e) {
  //
}; //定义外部接收数据的回调函数
let reConnectNum = 0; //重连次数
//心跳设置
var heartCheck = {
  get heartbeatData() {
    return {
      DevHeart: {
        value: "1",
      },
      token: store.state.user.token, // 获取最新的 token
      projectId: store.state.cadModules.rlProject_id,
    };
  },
  timeout: 10 * 1000, // 每隔60秒发送一次心跳包
  heartbeat: null, // 定时器对象
  start: function () {
    this.heartbeat = setInterval(() => {
      if (isConnect) {
        webSocketSend(this.heartbeatData); // 发送最新的 heartbeatData
      } else {
        this.clear();
      }
    }, this.timeout);
  },
  reset: function () {
    clearInterval(this.heartbeat);
    this.start();
  },
  clear: function () {
    clearInterval(this.heartbeat);
  },
};

//初始化websocket
function initWebSocket(callback) {
  if (store.state.app.isAndroid) return;

  //此callback为在其他地方调用时定义的接收socket数据的函数
  if (callback) {
    if (typeof callback == "function") {
      globalCallback = callback;
    } else {
      throw new Error("callback is not a function");
    }
  }
  if ("WebSocket" in window) {
    webSocket = new WebSocket(websocketUrl(store)); //创建socket对象
  } else {
    Message({
      message: "该浏览器不支持websocket!",
      type: "warning",
    });
    return;
  }
  //打开
  webSocket.onopen = function () {
    store.state.app.isWsError = false;
    store.state.app.isRoloadWs = false;
    webSocketOpen();
  };
  //收信
  webSocket.onmessage = function (e) {
    webSocketOnMessage(e);
  };
  //关闭
  webSocket.onclose = function (e) {
    //

    webSocketOnClose(e);
  };
  //连接发生错误的回调方法
  webSocket.onerror = function (e) {
    //
    webSocketonError(e);
  };
}

//连接socket建立时触发
function webSocketOpen() {
  if (store.state.app.isAndroid) return;
  //
  //首次握手
  webSocketSend(heartCheck.heartbeatData);
  isConnect = true;
  heartCheck.start();
  reConnectNum = 0;
}

export function isDateStrGreaterThanTimestampStr(dateStr, dateStr1) {
  // 将日期字符串转换为Date对象
  const date = new Date(dateStr);
  const date1 = new Date(dateStr1);
  return date.getTime() >= date1.getTime();
}
//客户端接收服务端数据时触发,e为接受的数据对象
function webSocketOnMessage(e) {
  if (store.state.app.isAndroid) return;
  const data = JSON.parse(e.data); //根据自己的需要对接收到的数据进行格式化
  if (data.code != 200 || data.code == 500) {
    Message.error("用户信息已过期，页面即将关闭!");
    setTimeout(() => {
      store.commit("user/logout"); // 清除用户信息
      // 关闭当前标签页
      window.close();
    }, 3000);
    return;
  }
  // console.log("data", data);
  if (data?.data?.user) {
    store.state.cadModules.userList = data.data.user;
    let hasUser = false;
    store.state.cadModules.applicationList = [];
    data.data.user.forEach((e) => {
      if (e.application === 1) {
        store.state.cadModules.applicationList.push(e);
      }
      console.log(
        "e.user_id === store.state.user.userInfo.id",
        e.user_id === store.state.user.userInfo.id
      );
      if (e.user_id === store.state.user.userInfo.id) {
        store.state.cadModules.lock = e.lock === 0;
        hasUser = true;
        store.state.cadModules.push_time = e.ydb_push_time;
        const changeTime = localStorage.getItem(
          `changeModelTimestamp-${store.state.cadModules.rlProject_id}`
        );
        if (
          (!changeTime && e.ydb_push_time) ||
          (changeTime &&
            isDateStrGreaterThanTimestampStr(e.ydb_push_time, changeTime))
        ) {
          store.state.cadModules.isSaveLoading = false;
        }
      }
    });
    if (!hasUser) {
      store.state.cadModules.lock = true;
    }
    if (
      store.state.cadModules.applicationList.length > 0 &&
      !store.state.cadModules.lock
    ) {
      store.state.cadModules.applicationShowDialogVisible = true;
    } else {
      store.state.cadModules.applicationShowDialogVisible = false;
    }
  }
  if (data?.message?.saveMethod === 5) {
    //保存次数已超时
    store.state.cadModules.isSaveLoading = false;
    store.state.cadModules.isSaveTips = "数据已上报，模型已锁定";
    // store.state.cadModules.lock = true;
  } else if (data?.message?.projectId) {
    store.state.cadModules.isSaveTips = "";
    // store.state.cadModules.lock = store.state.cadModules.lock;
  }
  globalCallback(data); //将data传给在外定义的接收数据的函数，至关重要。
}

//socket关闭时触发
function webSocketOnClose(e, value) {
  if (value !== undefined) {
    reConnectNum = value;
  }
  if (store.state.app.isAndroid) return;
  heartCheck.clear();
  isConnect = false; //断开后修改标识
  //
  //被动断开，重新连接
  if (e.code == 1006) {
    store.state.app.isRoloadWs = true;
    if (reConnectNum < 3) {
      setTimeout(() => {
        initWebSocket();
        ++reConnectNum;
      }, 1000);
    } else {
      store.state.app.isWsError = true;
      v.$message({
        message: "网络存储已断开，为防数据丢失，请在顶部点击重连!",
        type: "warning",
        showClose: true,
        duration: 0,
      });
    }
  } else {
    store.state.app.isWsError = false;
    store.state.app.isRoloadWs = false;
  }
}

//连接发生错误的回调方法
function webSocketonError(e) {
  if (store.state.app.isAndroid) return;
  heartCheck.clear();
  isConnect = false; //断开后修改标识
  //
}

//发送数据
function webSocketSend(data) {
  if (store.state.app.isAndroid) return;
  webSocket.send(JSON.stringify(data)); //在这里根据自己的需要转换数据格式
}
//在其他需要socket地方主动关闭socket
function closeWebSocket(e) {
  if (store.state.app.isAndroid) return;
  //
  webSocket.close();
  heartCheck.clear();
  isConnect = false;
  reConnectNum = 0;
}
//在其他需要socket地方接受数据
function getSock(callback) {
  if (store.state.app.isAndroid) return;
  globalCallback = callback;
}
//在其他需要socket地方调用的函数，用来发送数据及接受数据
function sendSock(agentData) {
  if (store.state.app.isAndroid) return;
  //下面的判断主要是考虑到socket连接可能中断或者其他的因素，可以重新发送此条消息。
  switch (webSocket.readyState) {
    //CONNECTING：值为0，表示正在连接。
    case webSocket.CONNECTING:
      setTimeout(function () {
        sendSock(agentData, callback);
      }, 1000);
      break;
    //OPEN：值为1，表示连接成功，可以通信了。
    case webSocket.OPEN:
      store.state.app.isWsError = false;
      store.state.app.isRoloadWs = false;
      webSocketSend(agentData);
      break;
    //CLOSING：值为2，表示连接正在关闭。
    case webSocket.CLOSING:
      setTimeout(function () {
        sendSock(agentData, callback);
      }, 1000);

      break;
    //CLOSED：值为3，表示连接已经关闭，或者打开连接失败。
    case webSocket.CLOSED:
      //
      webSocketOnClose();
      // do something
      break;
    default:
      // this never happens
      break;
  }
}
function changeReConnectNum(val) {
  reConnectNum = val;
}

export default {
  initWebSocket,
  closeWebSocket,
  sendSock,
  getSock,
  webSocketOnClose,
  changeReConnectNum,
};
